import React, { useEffect, useState } from "react";
import {
  ProductVariant,
} from "../../../actions/types";
import Variant from "./Variant";
import { selectVariant, setSelectedVariant } from "../products/productSlice";
import { useDispatch, useSelector } from "react-redux";

declare namespace I18n {
  function t(s: string): string;
}
declare function prefixURL(url: string): string;

type VariantsProps = {
  product_id: number;
  isCatalog: boolean;
  variants: ProductVariant[];
};

const Variants = ({ product_id, isCatalog, variants }: VariantsProps) => {
  const currentVariant = useSelector(selectVariant);
  const dispatch = useDispatch();

  useEffect(() => {
    if (variants.length && !currentVariant) {
      dispatch(setSelectedVariant(variants[0]));
    }
  }, [variants, currentVariant]);

  if (!variants.length) {
    return <></>;
  }

  return (
    <div className="featured-boxes mt-2">
      <div className="product__sidebar-hr"></div>
      <div className="row">
        <div className="col">
          <div className="featured-box featured-box-primary text-left mt-2">
            <div className="box-content">
              <div className="d-flex justify-content-between">
                <h6 className="color-primary font-weight-semibold text-4 text-uppercase mb-3">
                  {isCatalog
                    ? I18n.t("shop.show_variants")
                    : I18n.t("shop.choose_variants")}
                </h6>
              </div>
              <div className="row">
                {variants.map((variant, index) => (
                  <Variant variant={variant} index={index} key={variant.id} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Variants;
